import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { navy } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Divider', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      borderColor: `${navy[700]} !important`,

      [`${componentCls}-inner-text`]: {
        color: `#94a3b8 !important`,
      },
    },
  }
})
